/**
 * Figma header buttons (account, cart, Frame 3/5 in 13:327): the outline icon button with a 1 px
 * line instead of the shadow, 48 px; 38 px on phones so the compact row fits 390 px.
 */
export const HEADER_BUTTON = 'border-[#E2E5DF] shadow-none max-sm:size-[38px] max-sm:rounded-xl';
